import { Dashboard } from '@/features/dashboard/Dashboard';

/* /crm. Het dashboard zelf staat in src/features/dashboard. */
export default function CRMDashboard() {
  return <Dashboard />;
}
